import styled from 'styled-components'

export const ReportDetail = styled.p`
    color: ${({ theme }) => theme.green} !important;
    margin: auto 10px;
`
